import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './login.css';
import Title from '../components/common/title';
import Text from '../components/common/text';
import Btn from '../components/common/btn';
import LL from '../asserts/LL.png';

const Login = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className="login-page">
      <div className="login-card">

        <img src={LL} alt="logo" className="login-logo" />

        <Title t="title" title="Golden Hills" />
        <Text x="text login-sub" text="Luxury Real Estate Company" />

        <Text x="text login-label" text="Email Address" />
        <input
          className="login-input"
          type="email"
          placeholder="name@goldenhills.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Text x="text login-label" text="Password" />
        <input
          className="login-input"
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <a href="#forgot" className="login-forgot">Forgot Password?</a>

        <Link to="/">
          <Btn btn="Sign In" />
        </Link>

        <div className="login-divider" />

        <div className="login-contact">
          <Text x="text login-small" text="Need access?" />
          <a href="mailto:admin@goldenhills.com" className="login-contact-link">Contact us</a>
        </div>

        <Text x="text login-copy" text="© 2026 Golden Hills. All rights reserved." />

      </div>
    </div>
  );

};

export default Login;